const initialState = {
    data: {},
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_ZABBIX_HISTORY_REQUEST') {
        return initialState;
    }

    if (action.type === 'APM_ZABBIX_HISTORY_SUCCESS') {
        return {
            data: action.payload.reduce((acc, datapoint) => {
                if (!acc[datapoint.itemId]) {
                    acc[datapoint.itemId] = [];
                }
                acc[datapoint.itemId].push(datapoint);
                return acc;
            }, {}),
        };
    }

    if (action.type === 'APM_ZABBIX_HISTORY_FAILURE') {
        return initialState;
    }

    return state;
}

export default reducer;
